import { useTranslation } from 'react-i18next';
import React from 'react';
import { MusicNoteRounded } from '@mui/icons-material';
import Tooltip from '@src/components/Tooltip';
import { Button, Typography } from '@mui/material';
import { COLOR } from '@src/styles/color';

const AdjustBackgroundMusic = ({
  isMoreButton,
  synthesisRequest,
  handleOpenMusic,
}) => {
  const { t } = useTranslation();

  return (
    <div
      className={`group group-adjust-background-music ${
        isMoreButton && 'group-adjust-background-music-more-button'
      }`}
    >
      <Tooltip
        arrow
        title={`${t('backgroundMusicOption')} ${
          synthesisRequest.backgroundMusic?.name || ''
        }`}
        placement="top"
      >
        <Button
          data-id="open-background-music"
          className="custom-button margin-right"
          onClick={handleOpenMusic}
        >
          <MusicNoteRounded sx={{ fontSize: 24, color: COLOR.navyBlue }} />
          {synthesisRequest?.backgroundMusic?.name && (
            <Typography
              variant="body2"
              className="toolbar-text background-music-name"
            >
              {synthesisRequest?.backgroundMusic?.name}
            </Typography>
          )}
        </Button>
      </Tooltip>
    </div>
  );
};

export default AdjustBackgroundMusic;
